import { render, staticRenderFns } from "./maincategory.vue?vue&type=template&id=21abdf12"
import script from "./maincategory.vue?vue&type=script&lang=js"
export * from "./maincategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports